function Credential(data) {
    let credential = data || {};
    this.position = credential.position;
    this.value = credential.value;
    this.alg = credential.alg;
}
module.exports = Credential;  